import React, { useMemo, useState, useEffect } from 'react';
import initData from '../../data';
import styles from './index.module.css';
import Team from '../../components/Team';

// 预加载图片
const preloadImage = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
    });
};

const App = () => {
    const [key, setKey] = useState(initData[initData.length - 1].key);
    const [data, setData] = useState(initData[initData.length - 1]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        // 尝试从缓存加载图片
        const cachedImage = localStorage.getItem('backgroundImageData');
        if (cachedImage) {
            document.documentElement.style.setProperty('--background-image', `url(${cachedImage})`);
            setImageLoaded(true);
        }

        // 预加载新图片
        preloadImage('/images/background.jpg')
            .then(img => {
                // 使用 Canvas 压缩图片
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                const compressedData = canvas.toDataURL('image/jpeg', 0.8);
                
                // 缓存图片数据
                try {
                    localStorage.setItem('backgroundImageData', compressedData);
                } catch (e) {
                    console.warn('Failed to cache image:', e);
                }

                // 设置背景
                document.documentElement.style.setProperty('--background-image', `url(${compressedData})`);
                setImageLoaded(true);
            })
            .catch(error => {
                console.error('Failed to load background image:', error);
                setImageLoaded(true); // 即使加载失败也要移除加载效果
            });
    }, []);

    const maxTime = useMemo(() => {
        return Math.max(...data.scores.map(item => item.time));
    }, [data.scores]);

    const rankWidth = useMemo(() => {
        const containerWidth = window.innerWidth - 32;
        return Math.min(containerWidth, isMobile ? 600 : 800);
    }, [isMobile]);

    const baseTimeWidth = useMemo(() => {
        // 计算基础时间条宽度：总宽度减去固定元素宽度和间距
        const teamWidth = isMobile ? 120 : 160; // Team 组件宽度
        const timeTextWidth = isMobile ? 36 : 48; // 时间文本宽度
        const infoWidth = isMobile ? 90 : 120; // rankInfo 宽度
        const gaps = isMobile ? 24 : 32; // 总间距
        const maxTimeWidth = rankWidth - teamWidth - timeTextWidth - infoWidth - gaps;
        return maxTimeWidth;
    }, [rankWidth, isMobile]);

    return (
        <>
            <header className={`${styles.header} ${imageLoaded ? styles.loaded : ''}`} />
            <div className={styles.container}>
                <div className={styles.title}>
                    不断成长的烟绯
                </div>
                <div className={styles.subTitle} onClick={() => window.open('https://space.bilibili.com/482036178')}>
                    by @烟绯三月夏扬州
                </div>
                <div className={styles.sideBarContainer}>
                    {initData.map(item => (
                        <div
                            key={item.key}
                            className={`${styles.tabItemContainer} ${item.key === key ? styles.active : ''}`}
                            onClick={() => {
                                setKey(item.key);
                                setData(item);
                            }}
                        >
                            {item.name}
                        </div>
                    ))}
                </div>
                <div className={styles.rankContainer} style={{
                    width: rankWidth,
                }}>
                    {data.scores.sort((a, b) => a.time - b.time).map((item, index) => (
                        <div key={index} className={styles.rankItem} onClick={() => window.open(item.video)}>
                            <Team data={item.team} />
                            <div className={styles.rankTimeContainer}>
                                <div
                                    className={styles.rankTime}
                                    style={{
                                        width: `${(item.time / maxTime) * baseTimeWidth}px`,
                                    }}
                                />
                                <div className={styles.rankTimeText}>
                                    {item.time}s
                                </div>
                            </div>
                            <div className={styles.rankInfo}>
                                by&nbsp;@{item.name}&nbsp;{item.cost}金
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default App;
